import { fieldTypes } from './fieldTypes';

const textfieldTypes = {
  DATE: { id: 0, name: 'date' },
  TEXT: { id: 1, name: 'text' },
  NUMBER: { id: 2, name: 'number' },
  GEOLOCALIZATION: { id: 3, name: 'geolocalization' },
  CURRENCY: { id: 4, name: 'currency' },
  DATETIME: { id: 5, name: 'datetime' },
};

const labelSizes = {
  H1: { id: 0, name: 'h2' },
  H2: { id: 1, name: 'h2' },
  H3: { id: 2, name: 'h2' },
  H4: { id: 3, name: 'h2' },
  H5: { id: 4, name: 'h2' },
  H6: { id: 5, name: 'h2' },
};

const valueKeys = {
  [fieldTypes.CHECKBOX_GROUP.id]: 'list',
  [fieldTypes.LOOP.id]: 'listData',
};

const getValueKey = fieldType => {
  return valueKeys[fieldType] ?? 'value';
};

export { textfieldTypes, labelSizes, getValueKey };
